<template>
  <div class="container" :class="{'mobile-page-container': !isIos}" v-if="loadingPageOver" :style="iosOrAndroidStyle">
    <w-nav-bar
      :icon="'iconchevron-left'"
      nav_title="优惠活动"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />

    <div class="promotion-container">
      <div class="exchange">
        <div class="exchange-top">
          <div class="exchange-title">超级优惠券</div>
          <div class="exchange-content">
            <div class="new_invitation">
              <input v-model="exchangeCode" placeholder="请输入兑换码" id="invitation_partner"/>
              <input @click="submitExchangeCode" type="submit" value="使用" class="right-panel-btn"
                     data-disable-with="使用"/>
            </div>
          </div>
        </div>
        <div class="exchange-list">
          <div v-if="coupons.length > 0 ">
            <div v-for="coupon in coupons" :key="coupon.id" class="coupon">
              <div class="coupon-price" v-if="coupon.cent">
                ￥<span class="num"> {{coupon.cent/100}} </span>
                <i class="top"></i>
                <i class="bottom"></i>
              </div>
              <div class="coupon-price" v-if="!coupon.member_days && !coupon.cent">
                <span class="num"> {{coupon.discount * 10}}折 </span>
                <i class="top"></i>
                <i class="bottom"></i>
              </div>
              <div class="coupon-price" v-if="coupon.member_days">
                <span class="num"> {{coupon.member_days}}天 </span>
                <i class="top"></i>
                <i class="bottom"></i>
              </div>
              <div class="coupon-desc">
                <div class="coupon-title">
                  {{coupon.name}}
                </div>
                <div class="coupon-date">
                  {{coupon.expiry | timeFilter('YYYY-MM-DD')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

<!--      公众号二维码-->
<!--      <div class="promotions" v-if="!isBaidu && !isQQMini && !isAlipayClient">-->
<!--        <div class="invite free-membership-card-container">-->
<!--          <div class="title theme-color">-->
<!--            30天会员免费领-->
<!--          </div>-->
<!--          <div class="subtitle">-->
<!--            扫码关注公众号，领取超级会员-->
<!--          </div>-->
<!--          <img src="https://files.wondercv.com/%E4%BC%9A%E5%91%98%E9%A1%B5-30%E5%A4%A9%E5%85%8D%E8%B4%B9.png">-->
<!--        </div>-->
<!--      </div>-->
      <!-- 非快应用/支付宝/夸克/uc -->
<!--      <div class="invite" v-if="!(isQuickApp || isAlipayClient || isUCClient || isQuaReClient)">-->
<!--        <div class="h5-invite-title">现在邀请好友，免费获得会员！</div>-->
<!--        <div class="invite-link">-->
<!--          <div class="link">-->
<!--            <div class="invite-url">-->
<!--              分享链接邀请好友，成功邀请-->
<!--              <span class="no-top">3个好友</span> 注册，-->
<!--              <br/>就可以免费获得30天超级会员。-->
<!--            </div>-->
<!--&lt;!&ndash;            <a class="click-to-jump btn-theme" :href="inviteLink">邀请好友</a>&ndash;&gt;-->
<!--            <div class="click-to-jump btn-theme" @click="jumpToInvitation">邀请好友</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="has-registrant">-->
<!--        <div class="registrant-desc">-->
<!--          <p class="obtain-qualification">-->
<!--            已有-->
<!--            <span class="maturity-date">{{userDatas.invite_count || 0}}个</span> 好友注册，免费获得-->
<!--            <span class="maturity-date">{{userDatas.free_day || 0}}天</span> 超级会员-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="haimati" v-if="!miniApp">-->
<!--        <div class="title">证件照福利！</div>-->
<!--        <div class="desc">-->
<!--          点击免费领取海马体证件照-->
<!--          <span>20</span> 元代金券-->
<!--        </div>-->
<!--        <a class="btn-theme visible-xs"-->
<!--           href="http://hmp.mainto.cn/promotion_html/77e3d39c199cd4fa7720815cc5907e5e?f=2132" target="_blank">点击领取</a>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
	import WNavBar from "@/components/global/w-navbar";
  import qrcodeVue from 'qrcode-vue';
  import { envMixin, loginMixin, WxMixin } from '@/assets/js/mixin/global';
  import { componentsMixin } from '../../assets/js/mixin/components'
  import Cookies from 'js-cookie';
  import { userMixin } from '@/assets/js/mixin/user';
  import {
    toLogin,
    checkJWT,
    updateJWT,
    setupWebViewJavascriptBridge
  } from '@/assets/js/utils'
  // import api from '@/api/api-list';
  import {get_tUser} from "@/assets/js/utils";
	// import { getUserAgent, updateRouterBack, asyncDataAddJWT } from '@/assets/js/util'

	export default {
    mixins: [ envMixin, loginMixin, componentsMixin, WxMixin, userMixin ],
    components: {
			WNavBar,
      qrcodeVue
		},
		data () {
			return {
				exchangeCode: '',
				goBackIcon: 'iconchevron-left',
				userSignedIn: false,
				userDatas: '',
				inviteLink: '',
				coupons: '',
        miniApp: false,
        _t: '',
        host: window.location.origin
			}
		},
		async mounted () {

      let userInfo = await this.$api.user.getUserAccountInfo(this.cvAccountToken)
      console.log(userInfo,"====>userinfo")
      let _t = Cookies.get("_t");
      this._t = _t;
      this.wx_share(
        { title: '超级简历 - HR专家推荐的智能简历工具丨专业简历模板及案例' },
        '名企精英和专业人士都在用的的智能工具，帮助你快速制作一份完美的简历，找工作成功率翻倍！'
      )
			this.loadPageData()
			this.judgeEnv()
		},
		computed: {},
		methods: {
      // 跳转邀请页
      jumpToInvitation() {
        this.$router.push({path: `/account/users/${this.userDatas.g_identity}/invite`})
      },
      leftBtnClick() {
        if (window.history.length > 1) {
					window.history.back()
				} else {
          this.routeTo('/account/users/index')
				}
      },
			async loadPageData () {
				if (this._t) {
					this.userSignedIn = true
          let data = {coupon_plan: ''}
          let res = await this.$api.user.getAccountSpecialOffers(this.cvAccountToken, data)

          let {code, data: {coupons}} = res
          if (code === 1000) {
            this.coupons = coupons.filter(coupon => coupon.usable === true)
          }

          this.userDatas = res.data
          this.inviteLink = `${process.env.VUE_APP_LINK}/account/users/${this.userDatas.g_identity}/invite`

					// this.$api.user.getAccountUsersCurrent()
					// 	.then((response) => {
					// 		if (response.status === 1) {
					// 		  console.log(response,"====>")
					// 			this.userData = response.data
					// 			this.coupons = this.userData.coupons.filter(coupon => coupon.usable === true)
          //       console.log(this.coupons)
					// 			this.inviteLink = `${process.env.VUE_APP_LINK}/account/users/${this.userData.g_identity}/invite`
					// 		}
					// 	})
					// 	.catch(() => {
					// 		this.$toast({ message: '请求错误, 请重试' })
					// 	})
				}
			},
			returnFunction () {
				this.$router.back()
			},
			async submitExchangeCode () {
				if (this.exchangeCode === '') {
					this.showToast('兑换码不能为空')
          return
				}

        let datas = {partner: this.exchangeCode, coupon_plan: ''}
        let res = await this.$api.user.setSpecialOffers(this.cvAccountToken, datas)
        // let {code, data: {coupons, code_kind}, message} = res
        if (res.code === 1000) {
          this.coupons = res.data.coupons.filter(coupon => coupon.usable === true)
          // 'code_kind'
          this.exchangeCode = ""
          if (res.data.code_kind === 'member' && res.data.message.indexOf('30000') > -1) {
            this.showToast("恭喜成为超级简历终身会员！", 1500)
          }else if (res.data.code_kind === 'member') {
            this.showToast(res.data.message, 1500)
          }else {
            this.showToast(res.data.message, 1500)
          }
        } else {
          this.showToast(res.data ? res.data.error : res.message, 1500)
        }

				// if (this._t) {
				// 	this.$api.user.postExchangeCode({partner: this.exchangeCode})
				// 		.then((response) => {
				// 			if (response.status === 1) {
				// 				this.loadPageData()
				// 				this.showToast('恭喜你，兑换成功')
				// 			} else {
				// 				this.showToast(response.message)
				// 			}
				// 		})
				// 		.catch(() => {
				// 			this.showToast('请求错误，请重试')
				// 		})
				// } else {
				// 	// let response = await this.$api.global.storeLocation({ return_to: '/account/users/current' })
				// 	// if (response.code === 1000) {
				// 		toLogin(process.env.VUE_APP_HOST + '/account/users/current');
				// 	// }
				// }
			},
			judgeEnv () {
        // this.miniApp = getUserAgent('miniprogram')
        this.miniApp = navigator.userAgent.toLocaleLowerCase().includes('miniprogram')
			}
		},

	}
</script>
<style lang="scss" scoped>
  .container {
    // height: 100%;
    background-color: #f5f5f7;
    min-height: calc(100vh - 44px);
    // box-sizing: border-box;
    padding-top: 44px;
  }

  .promotion-container {
    left: 0;
    right: 0;
    padding: 0 20px;
    background: #f5f5f7;
    padding-bottom: 20px;
    height: 100%;
    .promotions {
      width: 100%;
      margin-bottom: 16px;
      box-sizing: border-box;
      padding-top: 8px;

      .invite {
        background-color: #fff;
        padding: 20px 20px 30px 20px;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        width: 100%;
      }

      .free-membership-card-container {
        text-align: center;
        box-sizing: border-box;

        .title {
          font-size: 24px;
          margin-top: 6px;
          font-weight: 500;
        }

        .subtitle {
          font-size: 15px;
          margin-top: 12px;
        }

        img {
          width: 125px;
          height: 125px;
          display: block;
          margin: 22px auto 0;
          vertical-align: middle;
          border: 0;
        }
      }
    }
  }

  // 兑换部分
  .exchange {
    padding: 0;
    min-height: 155px;
    border-radius: 8px;
    background: transparent;
    width: 100%;
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .exchange-content {
    margin-left: 18px;
    margin-top: 28px;
    display: flex;
    align-items: center;
  }

  .exchange-top {
    padding: 30px 0 48px 0;
    background: #fff;
    border-radius: 8px;
  }

  .exchange-list {
    // display: none;
    font-size: 14px;
    color: #666666;
    // width: 100%;
    padding-top: 0;
    display: block !important;

    .coupon {
      margin-top: 10px;
      // width: 100%;
      background: #fff;
      height: 120px;
      border-left: 3px solid #ff4f4c;
      line-height: 120px;
    }

    .coupon-price {
      color: #ff4f4c;
      margin-left: 6%;
      width: 30%;
      border-right: 1px dashed #d8d8d8;
      height: 100%;
      float: left;
      display: flex;

      .num {
        font-size: 30px;
      }

      i {
        height: 8px;
        width: 8px;
        position: absolute;
        border-radius: 50%;
        background: #ebebeb;
      }

      .top {
        left: 37%;
        margin-top: -4px;
      }

      .bottom {
        left: 37%;
        margin-top: 116px;
      }
    }

    .coupon-desc {
      line-height: 25px;
      margin: 35px 0;
      width: 60%;
      text-align: center;
      display: inline-block;

      .coupon-title {
        font-size: 18px;
        font-weight: bold;
      }

      .coupon-date {
        font-size: 14px;
        color: #ff4f4c;
      }
    }
  }

  .exchange-title {
    margin-left: 18px;
    color: #404040;
    font-size: 18px;
    line-height: 25px;
    text-align: left;
  }

  .new_invitation {
    width: 100%;
  }

  #invitation_partner {
    width: 80%;
    line-height: 32px;
    height: 32px;
    background: #fcfcfc;
    border: 1px solid #dedfe1;
    padding: 0 18px;
    outline: none;
  }

  .right-panel-btn {
    width: 40px;
    height: 32px;
    background: #ff4f4c;
    color: #fff;
    line-height: 32px;
    padding: 0;
    border-radius: 4px;
    text-align: center;
    margin-left: 6px;
  }

  // 邀请部分
  .invite {
    background-color: #fff;
    padding: 20px 20px 30px 20px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    background: #ffffff;
  }

  .h5-invite-title {
    color: #404040;
    font-size: 18px;
    line-height: 25px;
  }

  .click-to-jump {
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    color: #fff;
    text-align: center;
    height: 40px;
    line-height: 40px;
    width: 60%;
    border-radius: 4px;
  }

  .btn-theme {
    background: #ff4f4c !important;
    color: #ffffff !important;
    border: none !important;
  }

  .link {
    line-height: 25px;
  }

  .invite-url {
    width: 100%;
    margin-top: 10px;
    color: #666666;
  }

  .no-top {
    color: #50a4ff;
  }

  // 数据显示部分
  .has-registrant {
    padding: 20px;
    margin-top: 10px;
    color: #666666;
    border-radius: 8px;
    background-color: #fff;
  }

  .maturity-date {
    color: #50a4ff;
  }

  .haimati {
    border-radius: 8px;
    padding: 36px 20px !important;
    background: #ffffff;
    padding: 36px 40px;
    margin-top: 10px;
  }

  .haimati .title {
    font-size: 18px;
    margin-bottom: 6px;
    font-weight: 400;
    line-height: 25px;
  }

  .haimati .desc {
    font-size: 15px;
    color: #606060;
  }

  .btn-theme {
    margin: auto;
    border-radius: 4px;
    width: 177px;
    margin-top: 30px;
    height: 41px;
    line-height: 41px;
    text-align: center;
    background: #ff4f4c !important;
    color: #ffffff !important;
    border: none !important;
  }

  .visible-xs {
    display: block !important;
  }
</style>
